<!-- filepath: d:\PROGETTI\LOCALITAVICINEAZIENDE\localita-vicine-azienda\src\components\modali\ModalSessionExpired.vue -->
<template>
  <div class="modal-overlay" v-if="show">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Sessione Scaduta</h5>
      </div>
      <div class="modal-body">
        <p>La tua sessione è scaduta. Effettua nuovamente il login per continuare.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="onLogin">Login</button>
        <button type="button" class="btn btn-secondary" @click="closeModal" :disabled="isLoading">Chiudi</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalSessionExpired",
  props: {
    show: Boolean,
    isLoading: Boolean, // Aggiungi questa prop
  },
  methods: {
    onLogin() {
      this.$emit("login"); // Emette un evento per aprire la modale di login
    },
    closeModal() {
      this.$emit('update:show', false); // Chiude la modale
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1010;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 400px;
}

.modal-header {
  font-size: 18px;
  font-weight: bold;
}

.modal-body {
  margin: 15px 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}
</style>